import React, { PropTypes } from 'react';
import Translate from 'react-translate-component';
import { getVatById } from '../../views/invoice-tool/invoice-tool-helper';
import {
  toMoney,
  amountInclVat,
  calculateRotAmount,
  calculateRutAmount
} from '../../views/invoice-tool/amount/amount-helper';

export class InvoiceDetailsAmount extends React.Component {

  static propTypes = {
    invoice: PropTypes.object
  };

  getAmountInclVat () {
    return amountInclVat(this.props.invoice.currencyAmount, getVatById(this.props.invoice.taxId));
  }

  renderTaxDeductionPart (invoice) {
    const taxDeduction = invoice.hsd;
    if (taxDeduction) {
      if (taxDeduction.rot) {
        return (
          <div className='invoice-details-amount-details purple-background'>
            <Translate className='invoice-details-amount-title' content='AMOUNT_TO_BILL_HSD_ROT_EXCL_VAT' />
            <div className='invoice-details-amount-title'>
              {`${toMoney(calculateRotAmount(invoice.currencyAmount))} ${invoice.currencyName}`}
            </div>
          </div>
        );
      }

      if (taxDeduction.rut) {
        return (
          <div className='invoice-details-amount-details purple-background'>
            <Translate className='invoice-details-amount-title' content='AMOUNT_TO_BILL_HSD_RUT_EXCL_VAT' />
            <div className='invoice-details-amount-title'>
              {`${toMoney(calculateRutAmount(invoice.currencyAmount))} ${invoice.currencyName}`}
            </div>
          </div>
        );
      }
    }

    return null;
  }

  render () {
    let invoice = this.props.invoice;

    if (invoice) {
      const amount = `${toMoney(invoice.currencyAmount)} ${invoice.currencyName}`;
      const amountInclVat = `${toMoney(this.getAmountInclVat(invoice))} ${invoice.currencyName}`;
      return (<div className='invoice-details-part-container'>
        <Translate className='invoice-details-title' content='INVOICE_DETAILS_INVOICE_AMOUNT' />
        <div className='invoice-details-amount-container'>
          <div className='invoice-details-amount-details'>
            <Translate className='invoice-details-amount-title' content='INVOICE_AMOUNT' />
            <div className='invoice-details-amount-title'>{amount}</div>
          </div>
          {this.renderTaxDeductionPart(invoice)}
          <div className='invoice-details-amount-details light'>
            <div className='invoice-details-amount-details-subgroup'>
              <div className='invoice-details-amount-subtitle'>
                <Translate content='CURRENCY' />{': ' + invoice.currencyName}
              </div>
              <div className='invoice-details-amount-subtitle'>
                <Translate content='VAT' />: {getVatById(invoice.taxId)}%
              </div>
            </div>
            <div className='invoice-details-amount-subtitle'>
              <Translate content='AMOUNT_INCL_VAT' />: {amountInclVat}
            </div>
          </div>
        </div>
      </div>);
    }
    return null;
  }
}

export default InvoiceDetailsAmount;



/** WEBPACK FOOTER **
 ** ./src/components/invoice-details/amount.js
 **/